export default "__VITE_ASSET__Cm9wVM8X__"